import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import { ECacheKeys } from 'cache/CacheKeys';
import { getItemGroups } from 'api/resources/item';

export const useGetItemGroups = (
	projectCode: string,
	options?: UseQueryOptions<string[]>
) => {
	return useQuery<string[]>({
		queryKey: [ECacheKeys.Items, 'groups', projectCode],
		refetchInterval: false,
		refetchOnWindowFocus: false,
		queryFn: () => getItemGroups(projectCode),
		...(options || {}),
	});
};
